import { render, staticRenderFns } from "./DevHome.vue?vue&type=template&id=0f73d3c4&"
import script from "./DevHome.vue?vue&type=script&lang=js&"
export * from "./DevHome.vue?vue&type=script&lang=js&"
import style0 from "./DevHome.vue?vue&type=style&index=0&id=0f73d3c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports